export default __webpack_public_path__ + "static/media/Data-analystCr.967030fd.png";